import { React, useState, useEffect } from "react";

const PopUpOnecard2020Results = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let oneCardMarkets = [];
    let oneCardWinner = "";

    if (marketType == 57) {

        oneCardMarkets = [
            resultData.cat_rnr1,
            resultData.cat_rnr2,
            resultData.cat_rnr3,
        ].filter(Boolean);

        oneCardWinner = resultData.resultTxt || "";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="one-card" style={{ display: marketType == 57 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                {resultData.cat_rnr1}
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "center",
                                                        padding: "2px"
                                                    }}
                                                >
                                                    <div className="RSMImageView2ab">
                                                        <img
                                                            src={`/assets/images/cards/${resultData.ac1}.svg`}
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "45px",
                                                                height: "auto"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b>
                                            <span className="name" style={{ color: "#000" }}>
                                                {resultData.cat_rnr2}
                                            </span>
                                        </b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div
                                                    className="BFBCardFanViewab"
                                                    style={{
                                                        justifyContent: "center",
                                                        padding: "2px"
                                                    }}
                                                >
                                                    <div className="RSMImageView2ab">
                                                        <img
                                                            src={`/assets/images/cards/${resultData.ac2}.svg`}
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "45px",
                                                                height: "auto"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {oneCardMarkets.map((market, index) => {
                                            const winner = market === oneCardWinner;
                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                        textAlign: "center",
                                                        marginBottom: "18px"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: "22px",
                                                            fontWeight: "700"
                                                        }}
                                                    >
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpOnecard2020Results;

